import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-listformat/polyfill';
import React from 'react';
import { render } from 'react-dom';
import { App, appHistory } from './containers/App';
import './MediaManager.scss';
import { runFullStoryLogger } from './services/loggers/fullStoryLogger';
import { getLocale } from './utils/env/getLocale';
import { parentConnection, ParentConnectionEvent } from './services/parentConnection';

if (getLocale() === 'vi') {
  import('./MediaManager-vi.scss');
}

runFullStoryLogger();

appHistory.listen((location) => {
  parentConnection.emit(ParentConnectionEvent.RouteChanged, location);
});

render(<App />, document.getElementById('root'));
